// Time constants
export const FADE_TIME = 350; // In milliseconds
export const SHUTDOWN_TIMEOUT = 30; // In minutes

export const TYPED_HISTORY_MAX_LENGTH = 250;
